export enum PostMessageTypeEnum {
  USER_CONTEXT = "user-context",
  DATA_CAPTURING = "data-capturing",
  SAVE_PROGRESS = "save-progress",
  RENDER_PREVIEW = "render-preview",
}
